import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Preloader from '../helper/Preloader';
import ColorInit from '../helper/ColorInit';
import HeaderOne from '../components/HeaderOne';
import Breadcrumb from '../components/Breadcrumb';
import FooterOne from '../components/FooterOne';
import BottomFooter from '../components/BottomFooter';
import ShippingOne from '../components/ShippingOne';
import TermsConditions from '../components/TermsConditions';
import PrivacyPolicy from '../components/PrivacyPolicy';
import ShippingPolicy from '../components/ShippingPolicy';
import RefundPolicy from '../components/RefundPolicy';

const PoliciesHubPage = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('terms');

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tab = params.get('tab');
        if (tab && ['terms', 'privacy', 'shipping', 'refund'].includes(tab)) {
            setActiveTab(tab);
        }
    }, [location.search]);

    const tabTitles = {
        terms: 'Terms & Conditions',
        privacy: 'Privacy Policy',
        shipping: 'Shipping & Delivery Policy',
        refund: 'Cancellation, Return & Refund Policy',
    };

    return (
        <>
            <ColorInit color={false} />
            <Preloader />
            <HeaderOne />
            <Breadcrumb title={tabTitles[activeTab] || 'Policies'} />

            {/* Navigation Tabs Bar */}
            <div className="bg-white border-bottom border-gray-100 py-16">
                <div className="container container-lg">
                    <div className="d-flex align-items-center justify-content-center flex-wrap gap-12">
                        <button
                            onClick={() => setActiveTab('terms')}
                            className={`btn rounded-pill px-24 py-10 text-sm fw-semibold transition-2 ${
                                activeTab === 'terms'
                                    ? 'btn-main shadow-sm'
                                    : 'btn-outline-gray bg-white text-gray-700 hover-border-main-600'
                            }`}
                        >
                            <i className="ph ph-file-text me-6" /> Terms &amp; Conditions
                        </button>
                        <button
                            onClick={() => setActiveTab('privacy')}
                            className={`btn rounded-pill px-24 py-10 text-sm fw-semibold transition-2 ${
                                activeTab === 'privacy'
                                    ? 'btn-main shadow-sm'
                                    : 'btn-outline-gray bg-white text-gray-700 hover-border-main-600'
                            }`}
                        >
                            <i className="ph ph-shield-check me-6" /> Privacy Policy
                        </button>
                        <button
                            onClick={() => setActiveTab('shipping')}
                            className={`btn rounded-pill px-24 py-10 text-sm fw-semibold transition-2 ${
                                activeTab === 'shipping'
                                    ? 'btn-main shadow-sm'
                                    : 'btn-outline-gray bg-white text-gray-700 hover-border-main-600'
                            }`}
                        >
                            <i className="ph ph-truck me-6" /> Shipping &amp; Delivery
                        </button>
                        <button
                            onClick={() => setActiveTab('refund')}
                            className={`btn rounded-pill px-24 py-10 text-sm fw-semibold transition-2 ${
                                activeTab === 'refund'
                                    ? 'btn-main shadow-sm'
                                    : 'btn-outline-gray bg-white text-gray-700 hover-border-main-600'
                            }`}
                        >
                            <i className="ph ph-arrow-counter-clockwise me-6" /> Return &amp; Refund
                        </button>
                    </div>
                </div>
            </div>

            {/* Active Policy Render */}
            {activeTab === 'terms' && <TermsConditions />}
            {activeTab === 'privacy' && <PrivacyPolicy />}
            {activeTab === 'shipping' && <ShippingPolicy />}
            {activeTab === 'refund' && <RefundPolicy />}

            <ShippingOne />
            <FooterOne />
            <BottomFooter />
        </>
    );
};

export default PoliciesHubPage;
